<template lang="pug">
v-app
  v-navigation-drawer.navigation(dark v-model="drawer" clipped, app, overflow)
    v-list-item(style="height: 63px"  dense)
      v-list-item-content
        v-list-item-title.title
          | {{ ROLES_NAMES[userRole] }}
        v-list-item-subtitle(class="d-flex align-center")
          span.mr-1 Текущее время: {{ currentTime }}
    the-navigation
    template(v-slot:append)
      v-row.flex-reverse(justify="center")
        v-switch.ma-5(
          v-model="$vuetify.theme.dark",
          hide-details="auto",
          dark,
          primary,
          label="Сменить тему"
        )
  the-header(@toggle-drawer="drawer = !drawer")
  v-main
    router-view

  welcome-dialog
</template>

<script>
import { mapGetters } from 'vuex';
import TheNavigation from '@/components/TheNavigation/index.vue';
import TheHeader from '@/components/TheHeader/index.vue';
import WelcomeDialog from '@/components/dialogs/WelcomeDialog.vue';
import { ROLES_NAMES } from '@/constants';
import { utcToZonedTime, format } from 'date-fns-tz';

export default {
  name: 'App',
  components: {
    TheHeader,
    TheNavigation,
    WelcomeDialog,
  },
  data() {
    return {
      drawer: false,
      currentTime: '',
      intervalId: null,

      ROLES_NAMES,
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      userRole: 'auth/userRole',
      timezone: 'auth/timezone',
    }),
  },
  watch: {
    $route: {
      handler(val) {
        if (val.meta?.role?.includes('admin') && !this.userRole.includes('admin')) this.$router.push('/');
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.intervalId = setInterval(this.setCurrentTime, 1000);

    if (window.innerWidth > 1200) this.drawer = true;
  },

  beforeDestroy() {
    clearInterval(this.intervalId);
  },

  methods:{
    setCurrentTime() {
      const zonedDate = utcToZonedTime(new Date(), this.timezone);
      this.currentTime = format(zonedDate, 'HH:mm:ss');
    },

  },

};
</script>

<style lang="scss">
.navigation {
  .v-input__slot {
    flex-direction: row-reverse;
    .v-label {
      margin-right: 10px;
    }
  }
}
</style>
